module.exports = __webpack_public_path__ + "static/media/stadium_story02.382f19ae.mp4";